



























































































































































































import { Component, Vue } from "vue-property-decorator";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";
import { ssmPermissionService } from "@/shared/services/PermissionService";
import { RouterNames } from "@/router/routernames";

@Component
export default class ActiveUsersDashboard extends Vue {
  // Estado
  public loading: boolean = false;
  public activeCount: number = 0;
  public activeUsers: any[] = [];
  public search: string = "";
  public expanded: any[] = [];

  // Auto-refresh property
  public autoRefresh: boolean = true;
  private timer: number | null = null;
  public refreshInterval: number = 10000; // 10s

  // Configuración Tabla
  public headers = [
    { text: "Identificador (ID)", value: "Id", align: "start" },
    { text: "Nombre", value: "Name" },
    { text: "Email", value: "Email" },
    { text: "Rol", value: "Role", align: "center" },
    { text: "Ruta Actual", value: "CurrentRoute", align: "center" },
    { text: "Conectado Desde", value: "ConnectedAt", align: "end" },
    { text: "", value: "data-table-expand" },
  ];

  // Ciclo de vida
  public mounted() {
    if (!ssmPermissionService.hasPermission("Permissions.ActiveUsers.Menu")) {
      this.$router.push({ name: RouterNames.mainlayout });
      return;
    }
    this.loadData();
    if (this.autoRefresh) {
      this.startTimer();
    }
  }

  public beforeDestroy() {
    this.stopTimer();
  }

  // Métodos Data
  public async loadData() {
    this.loading = true;
    try {
      // Aprovechamos Promise.all para hacer las dos peticiones en paralelo
      const [countRes, listRes] = await Promise.all([
        ssmHttpService.get(`${API.activeUsers}/count`, null, false),
        ssmHttpService.get(`${API.activeUsers}/list`, null, false),
      ]);

      if (countRes) {
        this.activeCount = countRes.count || 0;
      }

      if (listRes && Array.isArray(listRes)) {
        // Sort by connection time descending (newest first)
        this.activeUsers = listRes.sort((a, b) => {
          return (
            new Date(b.ConnectedAt).getTime() -
            new Date(a.ConnectedAt).getTime()
          );
        });
      }
    } catch (e) {
      console.error("Error al cargar Active Users", e);
    } finally {
      this.loading = false;
    }
  }

  // Timer Methods
  public toggleAutoRefresh() {
    if (this.autoRefresh) {
      this.startTimer();
    } else {
      this.stopTimer();
    }
  }

  private startTimer() {
    this.stopTimer();
    this.timer = window.setInterval(() => {
      // En auto-refresh NO mostramos el loader circular global de la tabla para
      // no molestar mientras se está leyendo o interactuando
      this.loadBackgroundData();
    }, this.refreshInterval);
  }

  private stopTimer() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  private async loadBackgroundData() {
    try {
      const [countRes, listRes] = await Promise.all([
        ssmHttpService.get(`${API.activeUsers}/count`, null, false),
        ssmHttpService.get(`${API.activeUsers}/list`, null, false),
      ]);

      if (countRes) {
        this.activeCount = countRes.count || 0;
      }

      if (listRes && Array.isArray(listRes)) {
        this.activeUsers = listRes.sort((a, b) => {
          return (
            new Date(b.ConnectedAt).getTime() -
            new Date(a.ConnectedAt).getTime()
          );
        });
      }
    } catch (e) {
      // Silent error for background pulls
      console.warn("Background refresh failed", e);
    }
  }

  // Helpers UI
  public getRoleColor(role: string): string {
    if (!role || role.toLowerCase().includes("anon")) return "grey lighten-2";
    if (role.toLowerCase() === "administrador") return "error";
    if (role.toLowerCase() === "cliente") return "success";
    return "primary";
  }

  public formatDateTime(dateString: string): string {
    if (!dateString) return "";
    const d = new Date(dateString);
    return (
      d.toLocaleDateString("es-ES") +
      " " +
      d.toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      })
    );
  }
}
